import Collection from "../../../data-structures/collection"
import GoalUser from "./user"

const debug = false
// const debug = "GoalUsersCollection"

export default class GoalUsersCollection extends Collection<GoalUser> {
    static initFromJSON(data: any[]): GoalUsersCollection {
        const users: GoalUser[] = _.map(data, record=>{
            debug && console.log(debug, 'initFromJSON', record)
            return new GoalUser(record)
        })

        return new GoalUsersCollection(users)
    }
}